import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import React from 'react';

type AuthRouteProps = {
  children?: React.ReactNode;
};

const AuthRoute = ({ children }: AuthRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log('AuthRoute render:', { loading, hasUser: !!user });

  // First render - show loading spinner
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div role="status">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" />
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  // No user - redirect to login
  if (!user) {
    console.log('No authenticated user, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated - render protected content
  console.log('User is authenticated, rendering content');
  return children ? <>{children}</> : <Outlet />;
};

export default AuthRoute;
